import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-splash-screen-sliders',
  templateUrl: './splash-screen-sliders.component.html',
  styleUrls: ['./splash-screen-sliders.component.scss'],
  standalone: false,
})
export class SplashScreenSlidersComponent implements OnInit {
  @Input('isWhiteBackground') isWhiteBackground: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
